import AppData from "../model/AppData";

function ToName(props, path, data) {
    //获取域名
    let baseUrl = window.location.origin;
    baseUrl = `${baseUrl}/#`

    // let pos = path.search("/play"); //如果找不到就是-1
    let pos = -1;

    //测试本地域名
    // baseUrl = 'http://192.168.8.126:3000/#'




    if (window.android && window.android.toWeb && pos ==-1) {
        window.android.toWeb(baseUrl+path, data)
    } else if (window && window.webkit && window.webkit.messageHandlers && AppData.os == 'ios'  && pos == -1) {
        let str = JSON.stringify({ path: baseUrl+path, data: data })
        window.webkit.messageHandlers.ToNewWeb.postMessage(str);
    } else {
        props.history.push({ pathname: path,data: data });
    }
}


export default ToName